import {withFormsy} from 'formsy-react';
import React from 'react';

const PreferenceRating = (props) => {

    let values = TB.range(1, 6)
        .map(year => {
                return {
                    label: String(year),
                    value: year
                };
            }
        );

    let inputValue = String(props.getValue() || 1);

    inputValue = parseInt(inputValue);

    return (
        <div className={'form-group preference-rating ' + (props.className || '')}>

            <div className="preference-label">
                <p className="label-header">{props.label}</p>
                {props.subLabel && <p className="label-subheader">{props.subLabel}</p>}
            </div>
            <select className="preference-select" disabled={props.disabled} name={props.name} value={inputValue} onChange={e => {
                let choice = parseInt(e.currentTarget.value);
                props.setValue(choice)
            }}>
                {values.map(option => (
                    <option key={`${props.name}-op-${option.value}`} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>

        </div>
    )
};

const PreferenceRatingInput = withFormsy(PreferenceRating);

export default PreferenceRatingInput;
